import { useMemo, useState } from 'react'

function useQueryParams() {
  const [queryParams, setQueryParams] = useState('')

  const queryParamsHandler = useMemo(
    () => ({
      get: () => queryParams,
      set: newQueryParams => {
        setQueryParams(newQueryParams)
      },
    }),
    [queryParams],
  )

  return queryParamsHandler
}

export default useQueryParams
